export enum PropertyType {
    Boolean = "Boolean",
    Date = "Date",
    DateTime = "DateTime",
    Integer = "Integer",
    Number = "Number",
    String = "String",
    Url = "Url",
    Time = "Time",
    Entity = "Entity",
    DisplayFormat = "DisplayFormat",
    MaterialIcon = "MaterialIcon",
    Action = "PortalAction",
    TableLookup = "TableLookup",
    Page = "Page",
    PageLink = "PageLink",
    DataLink = "DataLink",
    Dropdown = "Dropdown",
    OptionSet = "OptionSet",
    Media = "Media",
    MediaSet = "MediaSet",
    ButtonStyle = "Style",
    BadgeStyle = "BadgeStyle",
    ControlSize = "ControlSize",
    Placement = "Placement",
    AggregateMethod = "AggregateMethod",
    GridOptions = "GridOptions",
    Enumeration = "Enumeration",
    CalendarOptions = "CalendarDataSource" 
}